export default __webpack_public_path__ + "static/media/downloadAppChatView.e6656ce9.png";